export const environment = {
  production: false,
  baseUrl: 'https://common.laalsa.com/paymentco',
  paymentBaseUrl:'http://common.laalsa.com/payment/'
};
